<template>
  <div class="Testimonial">
    <div class="quote">"{{ shortQuote }}"</div>
    <div class="attributed">{{ attributed }}</div>
    <div class="more link" role="link" tabindex="0" @click="toggleQuote">Read Full Quote</div>

    <transition name="vFadeMobile">
      <div class="fullTestimonial" v-if="open" @click="toggleQuote">
        <div class="close" role="button" tabindex="0"><span></span><span></span></div>
        <div class="quote">
          <div class="scroll">
            <slot name="fullQuote"></slot>
            <div class="attributed">{{ attributed }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Testimonial',
  props: {
    shortQuote: {
      type: String
    },
    attributed: {
      type: String
    }
  },
  data() {
    return {
      open: false
    }
  },
  methods: {
    toggleQuote() {
      this.open = !this.open
    }
  }
}
</script>

<style lang="scss" scoped>
.Testimonial {
  width: 900px;
  margin: 60px auto 80px auto;
  color: #000;
  text-align: center;

  & .quote {
    font-size: 28px;
    line-height: 44px;
    @include fontHeadItalic;
    margin: 0 0 20px 0;
  }
  & .attributed {
    @include fontBodyBold;
    font-size: 16px;
    line-height: 24px;
    margin: 0 0 30px 0;
    color: $greyDark;
  }
  & .more {
    cursor: pointer;
    @include fontBodyLight;
    font-size: 14px;
    line-height: 18px;
    text-decoration: underline;
    display: inline-block;

    &:hover {
      text-decoration: none;
    }
  }
  & .fullTestimonial {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(255,255,255,0.95);
    text-align: center;

    & .close {
      height: 50px;
      width: 50px;
      border-radius: 25px;
      border: 1px solid #000;
      background: #fff;
      position: relative;
      z-index: 5;
      margin: 30px auto 0 auto;
      transform-origin: center;
      cursor: pointer;
      transition: all 300ms;

      &:focus {
        outline: none;
      }

      & span {
        display: block;
        width: 31px;
        height: 2px;
        background: #000;
        position: absolute;
        left: 9px;
        top: 24px;
        transform-origin: center;

        &:first-child {
          transform: rotate(45deg);
          animation: closeOne 500ms 1;
        }
        &:last-child {
          transform: rotate(135deg);
          animation: closeTwo 500ms 1;
        }
      }
      @keyframes closeOne {
        from {transform: rotate(45deg) scaleX(0);}
        to {transform: rotate(45deg) scaleX(1);}
      }
      @keyframes closeTwo {
        from {transform: rotate(135deg) scaleX(0);}
        to {transform: rotate(135deg) scaleX(1);}
      }
      &:hover {
        transform: scale(1.2);
      }
    }
    & > .quote {
      position: absolute;
      width: 900px;
      top: 90px;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow-y: auto;

      & .scroll {
        margin: auto;
        font-size: 22px;
        line-height: 52px;

        & .attributed {
          margin: 30px 0 0 0;
        }
      }
    }
  }
  @media screen and (max-width: $breakLarge) {
    width: calc(100% - 60px);

    & .fullTestimonial {

      & > .quote {
        width: calc(100% - 60px);
      }
    }    
  }
  @media screen and (max-width: $breakMed) {
    margin: 50px auto 60px auto;

    & .quote {
      font-size: 26px;
      line-height: 38px;
      margin: 0 0 15px 0;
    }
    & .attributed {
      @include fontBodyBold;
      font-size: 15px;
      line-height: 22px;
      margin: 0 0 25px 0;
    }
    & .fullTestimonial {
      & > .quote {
        & .scroll {
          font-size: 20px;
          line-height: 40px;

          & .attributed {
            margin: 25px 0 0 0;
          }
        }
      }
    }
  }
  @media screen and (max-width: $breakSmall) {

    & .quote {
      font-size: 24px;
    }
    & .attributed {
      font-size: 14px;
      margin: 0 0 20px 0;
    }
    & .fullTestimonial {
      & > .quote {
        width: calc(100% - 40px);
        & .scroll {
          font-size: 20px;
          line-height: 36px;

          & .attributed {
            margin: 20px 0 0 0;
          }
        }
      }
    }
  }
  @media screen and (max-width: 360px) {
    & .fullTestimonial {
      & > .quote {
        & .scroll {
        font-size: 16px;
        line-height: 26px;
      }
      }
    }
  }
}

</style>
